import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowRight, FiLock } = FiIcons;

function LeadForm({ name = 'tech-reality-check', compact = false }) {
  const [status, setStatus] = useState('');

  const submit = (event) => {
    event.preventDefault();
    if (!event.currentTarget.checkValidity()) return;
    setStatus('Your details are validated, but submission storage is not connected yet. Please call us to book now.');
  };

  return (
    <form className={`lead-form ${compact ? 'compact' : ''}`} onSubmit={submit}>
      <div className="form-grid">
        <label>Full name<input name="name" autoComplete="name" required placeholder="Your name" /></label>
        <label>Work email<input name="email" type="email" autoComplete="email" required placeholder="you@company.com" /></label>
        <label>Company<input name="company" autoComplete="organization" required placeholder="Company name" /></label>
        <label>Phone<input name="phone" type="tel" autoComplete="tel" required placeholder="(718) 555-0123" /></label>
        {!compact && (
          <>
            <label>Area of interest
              <select name="interest" defaultValue="" required>
                <option value="" disabled>Select one</option>
                <option>UCaaS</option>
                <option>CCaaS</option>
                <option>Wireless</option>
                <option>Not sure yet</option>
              </select>
            </label>
            <label>Team size
              <select name="size" defaultValue="">
                <option value="">Select size</option>
                <option>20–49</option>
                <option>50–99</option>
                <option>100–249</option>
                <option>250–500</option>
                <option>500+</option>
              </select>
            </label>
            <label className="full">What should we know?
              <textarea name="message" rows="4" placeholder="Current provider, locations, or the problem you want to solve" />
            </label>
          </>
        )}
      </div>
      <button className="button button-primary form-submit" type="submit">
        Request My Free Assessment <SafeIcon icon={FiArrowRight} />
      </button>
      <p className="privacy-note"><SafeIcon icon={FiLock} /> No spam. No obligation. Your information stays private.</p>
      {status && <p className="form-status" role="status">{status}</p>}
      <div data-greta-form-placeholder={name}>This form is not collecting yet.</div>
    </form>
  );
}

export default LeadForm;